// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts` when building for production.
// The list of file replacements can be found in `angular.json`.
// Use: ng serve (dev) | ng build --configuration=production (prod)

export const environment = {
  production: false,

  // --- API (development: local backend) ---
  apiBaseUrl: 'https://dev.api.ftndemo.com/api/',
  apiBaseImageUrl: 'https://dev.api.ftndemo.com/api/media/',
  website_Url: 'https://dev.ftndemo.com',
  mockInterviewCalLink: 'tempftnuser',

  // --- LinkedIn OAuth (use dev redirect URI in LinkedIn app for localhost) ---
  linkedIn: {
    clientId: '77juay5c3rit7u',
    redirectUri: 'https://dev.ftndemo.com/auth/register/linkedin/callback',
    scope: 'r_liteprofile r_emailaddress'
  },

  // --- Google OAuth (dev) ---
  google: {
    clientId: '832580187458-cokfekqls95l0qht70ilbslfng4vcf0l.apps.googleusercontent.com',
    redirectUri: 'https://dev.ftndemo.com/auth/register/google/callback',
    scope: 'openid profile email'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
